export const POST_IMAGE_SEP = '|';
export const MAX_POST_PHOTOS = 10;

export const parsePostImages = (image) => {
  if (!image) return [];
  return String(image)
    .split(POST_IMAGE_SEP)
    .map(name => name.trim())
    .filter(Boolean);
};

export const firstPostImage = (image) => parsePostImages(image)[0] || '';

export const uploadUrl = (name) => {
  if (!name) return '';
  const raw = String(name);
  if (raw.startsWith('/') || raw.startsWith('http')) return raw;
  return `/api/uploads/${encodeURIComponent(raw)}`;
};

export const uniquePostFileName = (file, index = 0) => {
  const original = String(file?.name || '');
  const mime = String(file?.type || '');
  const fromType = /mp4/i.test(mime) ? '.mp4'
    : /mpeg|mp3/i.test(mime) ? '.mp3'
    : /wav/i.test(mime) ? '.wav'
    : /aac|m4a/i.test(mime) ? '.m4a'
    : /ogg/i.test(mime) ? '.ogg'
    : /webm/i.test(mime) ? '.webm'
    : /quicktime/i.test(mime) ? '.mov'
    : /png/i.test(mime) ? '.png'
    : /webp/i.test(mime) ? '.webp'
    : /gif/i.test(mime) ? '.gif'
    : /heic|heif/i.test(mime) ? '.heic'
    : /jpe?g/i.test(mime) ? '.jpg'
    : '.bin';
  const ext = (original.match(/\.[a-z0-9]{1,8}$/i) || [fromType])[0];
  const stamp = `${Date.now()}${index}`;
  const maxBase = Math.max(4, 70 - stamp.length - ext.length);
  const base = (original.replace(/\.[^.]+$/, '') || 'file').replace(/[^a-zA-Z0-9._-]/g, '').slice(0, maxBase) || 'file';
  return `${stamp}${base}${ext}`;
};

export const uploadPostFile = (file, index = 0, onProgress) => new Promise((resolve, reject) => {
  if (!file) {
    reject(new Error('No file to upload'));
    return;
  }
  const name = uniquePostFileName(file, index);
  const formData = new FormData();
  formData.append('myfile', file, name);
  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/api/up/poto');
  xhr.upload.onprogress = (event) => {
    if (!onProgress || !event.lengthComputable || !event.total) return;
    onProgress(Math.max(0, Math.min(1, event.loaded / event.total)));
  };
  xhr.onload = () => {
    let data = {};
    try { data = JSON.parse(xhr.responseText || '{}'); } catch (_) {}
    if (xhr.status >= 200 && xhr.status < 300) {
      resolve(data.name || name);
      return;
    }
    if (xhr.status === 413) {
      reject(new Error('File is too large. Choose a smaller file.'));
      return;
    }
    reject(new Error(data.msg || xhr.responseText || 'Upload failed. Please try again.'));
  };
  xhr.onerror = () => reject(new Error('Upload failed. Please try again.'));
  xhr.send(formData);
});
